module.exports = __webpack_public_path__ + "img/thee1-home.82ec2383.webp";